import type { TokaMapInstance } from '@tokamap/core';
import buildingPickStore        from '@/TokamapEditor/stores/buildingPickStore';

export default function toggleCutTool(instance: TokaMapInstance | null | undefined): void {
	if (!instance) return;

	const { mapAdapter } = instance;

	if (mapAdapter.isDrawingCut()) return mapAdapter.stopDrawingCut();

	if (buildingPickStore.active) buildingPickStore.stop();

	return mapAdapter.startDrawingCut();
}
